export var PfLogLevel;
(function (PfLogLevel) {
    PfLogLevel["INFO"] = "INFO";
    PfLogLevel["WARN"] = "WARN";
    PfLogLevel["ERROR"] = "ERROR";
    PfLogLevel["CRITICAL"] = "CRITICAL";
})(PfLogLevel || (PfLogLevel = {}));
export var PfStep;
(function (PfStep) {
    PfStep["QUICK_QUOTE"] = "Quick Quote";
    PfStep["CREATE_QUOTE"] = "Create Quote";
    PfStep["SIGN_PFA"] = "Sign PFA";
    PfStep["SETUP_ACH"] = "Setup ACH";
    PfStep["UPLOAD_PFA"] = "Upload PFA";
    PfStep["BIND_QUOTE"] = "Bind Quote";
    PfStep["ALLOCATE_PAYMENT"] = "Allocate Payment";
    PfStep["PATCH_ALLOCATION"] = "Patch Allocation";
    PfStep["PUBSUB_EVENT"] = "PubSub Event";
    PfStep["GET_LOAN"] = "Get Loan";
})(PfStep || (PfStep = {}));
export var PfSystem;
(function (PfSystem) {
    PfSystem["APPLIED_PAY"] = "Applied Pay";
    PfSystem["MMS"] = "MMS";
    PfSystem["PFP"] = "PFP";
    PfSystem["AMS"] = "AMS";
    PfSystem["ADYEN"] = "Adyen";
})(PfSystem || (PfSystem = {}));
export var PfWorkflow;
(function (PfWorkflow) {
    PfWorkflow["EPIC_GENERATE_INVOICE"] = "EPIC Generate Invoice";
    PfWorkflow["EPIC_PFC"] = "EPIC PFC";
    PfWorkflow["HPP"] = "HPP";
})(PfWorkflow || (PfWorkflow = {}));
// matches PfProvider prisma enum
export var PfErrorCategory;
(function (PfErrorCategory) {
    PfErrorCategory["PFP_API_ERROR"] = "PFP_API_ERROR";
    PfErrorCategory["AMS_API_ERROR"] = "AMS_API_ERROR";
    PfErrorCategory["MISSING_DATA"] = "MISSING_DATA";
    PfErrorCategory["PFC_DATA_MISSING"] = "PFC_DATA_MISSING";
    PfErrorCategory["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    PfErrorCategory["PAYMENT_ERROR"] = "PAYMENT_ERROR";
    PfErrorCategory["AUTHORIZATION_ERROR"] = "AUTHORIZATION_ERROR";
    PfErrorCategory["PF_NOT_ENABLED"] = "PF_NOT_ENABLED";
    PfErrorCategory["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
    PfErrorCategory["OTHER"] = "OTHER";
})(PfErrorCategory || (PfErrorCategory = {}));
//# sourceMappingURL=PremiumFinance.js.map